/**
 * Product → subtype question mapping (shared — avoids circular imports).
 */

export const SUBTYPE_QUESTION_IDS = [
  'commerce_style',
  'internal_style',
  'ai_style',
  'data_style',
  'distributed_style',
  'api_style',
  'migration_style',
  'saas_style',
  'mobile_style',
  'iot_style',
  'integration_style',
  'search_style',
  'marketing_style',
] as const;

export type SubtypeQuestionId = (typeof SUBTYPE_QUESTION_IDS)[number];

const SUBTYPE_BY_PRODUCT: Partial<Record<string, SubtypeQuestionId>> = {
  ecommerce: 'commerce_style',
  internal: 'internal_style',
  ai: 'ai_style',
  data: 'data_style',
  distributed: 'distributed_style',
  api_platform: 'api_style',
  migration: 'migration_style',
  saas: 'saas_style',
  mobile: 'mobile_style',
  iot: 'iot_style',
  integration: 'integration_style',
  search: 'search_style',
  marketing: 'marketing_style',
};

export const SUBTYPE_STANDARD_ID = 'standard';

export function subtypeQuestionIdForProduct(product?: string): SubtypeQuestionId | null {
  if (!product) return null;
  return SUBTYPE_BY_PRODUCT[product] || null;
}

/** True when user picked a concrete subtype (not “standard / typical”). */
export function isExplicitSubtype(value?: string): boolean {
  return Boolean(value && value !== SUBTYPE_STANDARD_ID);
}

/** Resolver input — treat standard / empty as “use default branch”. */
export function effectiveSubtype(value?: string): string | undefined {
  if (!value || value === SUBTYPE_STANDARD_ID) return undefined;
  return value;
}
